<template>
  <a
    href="tel:1300174287"
    class="font-medium md:text-lg"
    :class="color">
    <div class="max-sm:hidden">
      <Icon
        name="heroicons:phone-solid"
        class="size-4" />
    </div>

    1300 174 287
  </a>
</template>

<script setup lang="ts">
defineProps<{
  color?: string
}>()

const { gtag } = useGtag()

onMounted(async () => {
  await nextTick()
  try {
    gtag('event', 'phone_conversion', {
      phone_conversion_number: '1300 174 287',
    })
  }
  catch (error) {
    console.warn('Error with phone conversion number', error)
  }
})
</script>
